import { useEffect, useState } from 'react';
import { CHAPTER_KEYS } from './chapters';

/*
 * What the viewer has watched, kept in this browser: the topics seen and the
 * step to continue from. Steps are stored by id (not by time) because the
 * timeline's durations change with the language.
 */
const STORAGE_KEY = 'habcare.userGuide.progress';
const CHANGE_EVENT = 'habcare:user-guide-progress';

/** Topics counted on the card (the opening and the closing are not topics). */
export const TOPIC_KEYS = CHAPTER_KEYS.filter((key) => key !== 'intro' && key !== 'end');

const EMPTY = { watched: [], resume: null };

export const readProgress = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    return {
      watched: Array.isArray(stored?.watched) ? stored.watched.filter((key) => CHAPTER_KEYS.includes(key)) : [],
      resume: typeof stored?.resume === 'string' ? stored.resume : null,
    };
  } catch {
    return EMPTY;
  }
};

export const updateProgress = (change) => {
  const next = { ...readProgress(), ...change };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Depolama kapalıysa ilerleme yalnızca bu açılışta bilinir
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

export const markWatched = (chapter) => {
  const { watched } = readProgress();
  if (!watched.includes(chapter)) updateProgress({ watched: [...watched, chapter] });
};

/** Progress that follows changes made by the player (and other tabs). */
export const useGuideProgress = () => {
  const [progress, setProgress] = useState(readProgress);
  useEffect(() => {
    const sync = () => setProgress(readProgress());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return progress;
};
